var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-rows"},[_c('Autocomplite',{attrs:{"postfix":'region',"label":_vm.$t('html.buAuto.region'),"placeholder":_vm.$t('html.buAuto.region'),"value":_vm.selectedId,"options":_vm.optionsList,"ga":_vm.ga},on:{"change":_vm.selectAutocomplite,"input":_vm.inputAutocomplite,"esc":_vm.escAutocomplite}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }